import {fetchDelete, generateEndpoint} from "../utils/request";

export const deleteMeasurement = async({ token, id }) => {
  const url = `${generateEndpoint('deleteMeasurement')}`
  return fetchDelete(url, token, { id })
}
